export function toast(payload: { type: string; message: string }): Promise<void> {
  return this.API.request('toast', payload)
}
